export const SET_ITEM = 'SET_ITEM';
export const DETAIL_CURRENT_SKU_INFO = 'DETAIL_CURRENT_SKU_INFO';
export const DETAIL_TAB_INDEX = 'DETAIL_TAB_INDEX';
export const DETAIL_SET_ISOPEN_SHOPPE = 'DETAIL_SET_ISOPEN_SHOPPE';
export const DETAIL_SET_SCROLL_OVER_DESC = 'DETAIL_SET_SCROLL_OVER_DESC';
export const DETAIL_SET_SHOW_ACTIVTIES_DIALOG = 'DETAIL_SET_SHOW_ACTIVTIES_DIALOG';
export const DETAIL_SET_SHOW_CROSS_DIALOG = 'DETAIL_SET_SHOW_CROSS_DIALOG';
export const DETAIL_SET_SHOW_PROMISE_DIALOG = 'DETAIL_SET_SHOW_PROMISE_DIALOG';
export const DETAIL_SET_SHOPPE_INFO = 'DETAIL_SET_SHOPPE_INFO';
export const DETAIL_SET_COLOR_COUNTDOWN_STYLE = 'DETAIL_SET_COLOR_COUNTDOWN_STYLE';
export const DETAIL_SET_COLOR_BOTTOMBTN_STYLE = 'DETAIL_SET_COLOR_BOTTOMBTN_STYLE';
export const DETAIL_RESET = 'DETAIL_RESET';

